<!--START TESTIMONIAL-->

<section class="section pt-4" id="team">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <h1 class="section-title text-center">TEAM</h1>
        <div class="section-title-border mt-3"></div>
        <p class="section-subtitle text-muted text-center font-secondary pt-4">The team ALGEBRAIC TECHNOLOGIES is a group of scientists and programmers with over 25 years of experience in the usage of formal methods in industry and scientific research.           Today, we are focusing on blockchain platform-based applications, including consensus algorithms, blockchain cybersecurity and token economy.</p>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-lg-3 col-sm-6">
        <div class="team-box text-center hover-effect">
          <div class="team-wrapper">
            <div class="team-member">
              <img alt="" src="assets/images/team/img-1.jpg" class="img-fluid rounded">
            </div>
          </div>
          <h4 class="team-name">Dr Oleksandr Letychevskyi</h4>
           <p class="text-uppercase team-designation">Professor</p>
          </div>
          <br>
          <p class="text-muted text-center mb-0">A scientist-algebraist, he has been engaged in formal methods in the verification of various subject areas for many years. The author of numerous works on using algebraic modelling in the blockchain area. Oleksandr is a professor at the Herriot-Watt University (Edinburgh). He also worked as a contractor at Motorola for the application of algebraic methods in the testing and verification of software and hardware systems and as a project leader, architect, and scientific leader in research.</p>
      </div>

      <div class="col-lg-3 col-sm-6">
        <div class="team-box text-center hover-effect">
          <div class="team-wrapper">
            <div class="team-member">
              <img alt="" src="assets/images/team/img-2.jpg" class="img-fluid rounded">
            </div>
          </div>
          <h4 class="team-name">Dr Volodymyr Peschanenko</h4>
           <p class="text-uppercase team-designation">Professor</p>
        </div>
        <br>
        <p class="text-muted text-center mb-0">Co-founder of Algebraic Technologies LTD and private enterprise Litsoft, Volodymyr is also Chair of the Department of Computer Science and Software Engineering of Kherson State University. His strengths are insertion modelling, symbolic modelling, deductive systems, the development of mathematical software, and computer algebra algorithms. Volodymyr has more than 100 scientific publications in informatics.</p>
      </div>

      <div class="col-lg-3 col-sm-6">
        <div class="team-box text-center hover-effect">
          <div class="team-wrapper">
            <div class="team-member">
              <img alt="" src="assets/images/team/img-3.jpg" class="img-fluid rounded">
            </div>
          </div>
          <h4 class="team-name">Vladyslav Volkov</h4>
           <p class="text-uppercase team-designation">PhD</p>
        </div>
        <br>
        <p class="text-muted text-center mb-0">Senior researcher at the V.M. Glushkov Institute of Cybernetics of the National Academy of Sciences of Ukraine. Researcher with over 30 years of experience in applying of formal methods to automated test generation and requirements verification, algebraic programming and insertion modelling. Author of more than 40 scientific publications. Manager of software development projects with over 20 years of experience especially in CMM/CMMI and Agile based process models.</p>
      </div>

      <div class="col-lg-3 col-sm-6">
        <div class="team-box text-center hover-effect">
          <div class="team-wrapper">
            <div class="team-member">
              <img alt="" src="assets/images/team/img-4.jpg" class="img-fluid rounded">
            </div>
          </div>
          <h4 class="team-name">Yuliia Tarasich</h4>
          <p class="text-uppercase team-designation">PhD</p>
        </div>
        <br>
        <p class="text-muted text-center mb-0">Doctoral student of the V.M. Glushkov Institute of Cybernetics of the National Academy of Sciences of Ukraine and researcher of the private company LitSoft and LTD Algebraic Technologies. She is the author of numerous scientific publications in informatics and information technologies. Her research interests include insertion modelling, symbolic modelling, algebraic modelling, tokenomics, and scientometrics.</p>
      </div>

    </div>
  </div>
</section>

<!--END TESTIMONIAL-->

<!--START PROCESS-->
<section class="section bg-light" id="workProc">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <h1 class="section-title text-center">Work Process</h1>
        <div class="section-title-border mt-3"></div>
        <p class="section-subtitle text-muted text-center font-secondary pt-4">Our team will help you to develop a
          successful project, supporting you on every stage of product development, from an idea up to mass adoption and
          scaling of any of your projects on the blockchain.</p>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-6 text-center process-left-icon-1">
        <i class="pe-7s-angle-right"></i>
      </div>
      <div class="col-lg-6 text-center process-left-icon-2">
        <i class="pe-7s-angle-right"></i>
      </div>
      <div class="col-lg-6 text-center process-left-icon-3">
        <i class="pe-7s-angle-left"></i>
      </div>
      <div class="col-lg-6 text-center process-left-icon-4">
        <i class="pe-7s-angle-left"></i>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-lg-4 plan-line">
        <div class="text-center process-box">
          <i class="pe-7s-pen text-primary"></i>
          <h4 class="padding-t-15">Tell us what you need.</h4>
          <p class="text-muted">We’ll help to design or test your idea and advise on the key elements that will ensure
            the product will last for a long period of time.</p>
        </div>
      </div>
      <div class="col-lg-4 plan-line">
        <div class="text-center process-box">
          <i class="pe-7s-id text-primary"></i>
          <h4 class="padding-t-15">Get a unique and competitive project.</h4>
          <p class="text-muted">With our help, you’ll develop a thoughtful, investment-attraction and product
            realization project.</p>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="text-center process-box">
          <i class="pe-7s-target text-primary"></i>
          <h4 class="padding-t-15">Launch high-quality product.</h4>
          <p class="text-muted">We'll provide you with consulting for the successful launch of your product and tools
            for subsequent live monitoring & control.</p>
        </div>
      </div>
      <div class="text-center mx-auto">
        <a href="https://tokenomics.expert/" class="btn btn-primary waves-light waves-effect mt-5" target="_blank">Get Started <i
            class="mdi mdi-arrow-right"></i></a>
      </div>
    </div>
  </div>
</section>
<!--END PROCESS-->

<!--START TESTIMONIAL-->
<section class="section" id="testi">
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2">
        <h1 class="section-title text-center">We've worked with</h1>
        <div class="section-title-border mt-3"></div>
        <p class="section-subtitle text-muted text-center font-secondary pt-4">The models of these projects' token economy were created and verified using the current version of the Cryptocurrency project support system MVP, which has been operational for over two years. It includes a Tokenomics Constructor, an Insertion Model Creator tool (for formal token economy model creation), and an Algebraic Server supporting the use of formal methods.</p>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-lg-4">
        <div class="testimonial-box hover-effect mt-4">
          <img src="assets/images/testimonials/Mesh-1-1.png" alt=""
            class="img-fluid d-block img-thumbnail rounded-circle">
          <div class="testimonial-decs">

            <p class="text-muted text-center mb-0"><b>Mesh+</b> was designed to bring users the very best in IoT with sustainable tokenomics that would contribute to building the network of the future. Now it's a <b>Chirp</b>, decentralized networking with Blackbird and Cardinal, that includes not just the IoT but also the broadband internet. </p>
          </div>
          <h5 class="text-center text-uppercase pt-3">MESH+ - <span
              class="text-muted text-capitalize"><a href="assets/documents/Mesh+TokenomicsPaper.pdf" target="_blank">Tokenomics Paper</a></span></h5>
        </div>
      </div>
      <div class="col-lg-4">
        <div class="testimonial-box hover-effect mt-4">
          <img src="assets/images/testimonials/8F_LOGO.png" alt=""
            class="img-fluid d-block img-thumbnail rounded-circle">
          <div class="testimonial-decs">
            <p class="text-muted text-center mb-0"><b>8.Finance</b> is an educational and marketing platform that helps everyone join the Crypto World and helps projects attract new users and entertain their current communities by providing abilities to run Airdrops, Tournaments and Educational videos with Quizzes about their projects in the Games.</p>
          </div>
          <h5 class="text-center text-uppercase pt-3">8.Finance - <span
              class="text-muted text-capitalize"><a href="assets/documents/8.FINANCE_TokenomicsPaper.pdf" target="_blank">Tokenomics Paper</a></span></h5>
        </div>
      </div>
      <!--<div class="col-lg-4">
        <div class="testimonial-box hover-effect mt-4">
          <img src="assets/images/testimonials/user-3.jpg" alt=""
            class="img-fluid d-block img-thumbnail rounded-circle">
          <div class="testimonial-decs">
            <p class="text-muted text-center mb-0">“I've learned that people will forget what you said, people will
              forget what you did, but people will never aliquam in nunc quis tincidunt forget how you vestibulum
              egestas them feel.” </p>
          </div>
          <h5 class="text-center text-uppercase pt-3">Theresa D. Sinclair - <span
              class="text-muted text-capitalize">Lynchburg</span></h5>
        </div>
      </div>-->
    </div>
  </div>
</section>
<!--END TESTIMONIAL-->

<!--START GET STARTED-->
<section class="section section-lg bg-get-start">
  <div class="bg-overlay"></div>
  <div class="container">
    <div class="row">
      <div class="col-lg-8 offset-lg-2 text-center">
        <h1 class="get-started-title text-white">Algebraic Technologies Ltd</h1>
        <div class="section-title-border mt-4 bg-white"></div>
        <p class="section-subtitle font-secondary text-white text-center pt-4">&#171;Is there a simple and efficient way to
          help blockchain project creators to avoid mistakes and create self-sustainable token economies right at the
          stage of white paper and MVP development?
          <br>
          <br>
          The answer is - math and formal methods&#187;</p>
        <!--<a href="javascript: void(0);" class="btn btn-white waves-effect mt-3 mb-4">Get Started <i
            class="mdi mdi-arrow-right"></i> </a>-->
      </div>
    </div>
  </div>
  <div class="bg-pattern-effect bg-pattern-light">
    <!-- <img src="assets/images/bg-pattern-light.png" alt=""> -->
    <svg width="100%" height="43" viewBox="0 0 2002 43" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 9.49999V42L1998.5 40V23H1962L1879 33L1758.5 36L1703 29.5L1304.5 21.5C1285.3 15.5 1183.83 24 1135.5 29L636 35.5C455.2 1.89999 136.667 4.16665 0 9.49999Z"
        fill="white" fill-opacity="0.1" />
      <path opacity="0.1"
        d="M0 33.5V41.5L1997.5 42V27H1972.5C1585.3 -21.8 1403.17 6.66666 1360.5 27C1299.7 13.4 1035.17 6 910.5 4C856.1 -6.8 597.5 8.5 475 17.5L0 33.5Z"
        fill="white" />
      <path
        d="M0 31.6689V42.1689L2001.5 41.6689V11.6689L1942.25 18.3143C1910.49 21.8758 1879.21 29.7147 1847.38 32.5593C1799.52 36.8366 1750.41 29.3968 1727 23.6689C1577.8 -8.33114 1367.17 10.3355 1280.5 23.6689C1199.3 40.8689 1126.17 30.8355 1106 23.6689C1023.13 -2.89279 818.252 7.7814 689.669 19.2529C659.224 21.9691 629.271 29.2178 598.77 31.21C559.856 33.7516 520.953 28.0794 502 23.6689C395.2 -8.73115 122.833 15.1689 0 31.6689Z"
        fill="white" />
    </svg>
  </div>
</section>
<!--END GET STARTED-->